import { supabase } from '../../client';
import { logError } from '@/lib/sentry';

// 같은 탭 내 계좌 변경 알림(증분2 codexloop R2 #1): nav 배지의 계정상태 재판정 트리거.
// realtime은 DELETE 이벤트에 채널 필터가 적용되지 않아(supabase 제약) hard delete를 놓친다 —
// 실제 해제 경로(연동 계좌 관리 다이얼로그)는 같은 탭이므로 DOM 이벤트가 확실한 채널.
export const DEPOSIT_ACCOUNT_CHANGED_EVENT = 'seller-deposit-account-changed';
function emitAccountChanged(): void {
  window.dispatchEvent(new CustomEvent(DEPOSIT_ACCOUNT_CHANGED_EVENT));
}

export interface SellerDepositAccount {
  id: number;
  bank_name: string | null;
  account_number: string;
  is_active: boolean;
  created_at: string;
}

export async function listAccounts(): Promise<SellerDepositAccount[]> {
  const { data, error } = await supabase
    .from('seller_deposit_account')
    .select('id, bank_name, account_number, is_active, created_at')
    .order('created_at', { ascending: false });
  if (error) { logError('listAccounts', error); throw error; }
  return data ?? [];
}

// account_number는 숫자만. user_id는 DB default auth.uid().
export async function addAccount(bankName: string, accountNumber: string): Promise<void> {
  const digits = accountNumber.replace(/\D/g, '');
  const { error } = await supabase
    .from('seller_deposit_account')
    .insert({ bank_name: bankName || null, account_number: digits });
  if (error) { logError('addAccount', error); throw error; }
  emitAccountChanged();
}

export async function setActive(id: number, isActive: boolean): Promise<void> {
  const { error } = await supabase
    .from('seller_deposit_account')
    .update({ is_active: isActive, modified_at: new Date().toISOString() })
    .eq('id', id);
  if (error) { logError('setActive', error); throw error; }
  emitAccountChanged();
}

// hard delete. FK 정책상 verification(1:1)은 함께 삭제(CASCADE),
// parsed_deposit/onboarding_session 이력은 보존되고 account 링크만 NULL 해제됨.
export async function deleteAccount(id: number): Promise<void> {
  const { data, error } = await supabase
    .from('seller_deposit_account')
    .delete()
    .eq('id', id)
    .select('id'); // 실제 삭제행 확인(RLS/stale id로 0행이면 거짓 성공 방지)
  if (error) { logError('deleteAccount', error); throw error; }
  if (!data || data.length === 0) {
    const e = new Error('deleteAccount: no row deleted');
    logError('deleteAccount', e);
    throw e;
  }
  emitAccountChanged();
}
